import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Spinner from 'src/Components/Spinner';
import IntervalTicker from 'src/utils/intervalTicker';
import { formatTimeSpanMilliseconds } from 'src/utils/date';

const MintButton = ({
  className,
  title,
  onClick,
  disabled,
  loading,
  expiredTime,
  onFinished
}) => {
  const [remaining, setRemaining] = React.useState(0);
  React.useLayoutEffect(() => {
    if (!expiredTime) {
      return () => {};
    }

    const intervalTicket = new IntervalTicker(Date.now(), expiredTime, timestamp => {
      setRemaining(timestamp);
    }, () => {
      setRemaining(0);
      onFinished && onFinished();
    });
    intervalTicket.start();
    return () => {
      intervalTicket.clear();
    };
  }, [expiredTime, onFinished]);
  return /*#__PURE__*/React.createElement("button", {
    disabled: disabled || loading,
    onClick: onClick,
    className: classNames(styles.container, className)
  }, !loading ? /*#__PURE__*/React.createElement("div", {
    className: styles.wrapTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title), !!remaining && /*#__PURE__*/React.createElement("div", {
    className: styles.wrapTimeout
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.timeout
  }, formatTimeSpanMilliseconds(remaining)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    className: styles.loading,
    secondary: true,
    size: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title)));
};

export default MintButton;